// Hook de autenticación - Wrapper sobre el store de auth
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export function useAuth() {
  const navigate = useNavigate();
  const authStore = useAuthStore();

  const logout = useCallback(() => {
    authStore.logout();
    navigate('/');
  }, [authStore, navigate]);

  const loginAndRedirect = useCallback(
    async (email: string, password: string) => {
      await authStore.login(email, password);
      navigate('/');
    },
    [authStore, navigate]
  );

  const registerAndRedirect = useCallback(
    async (username: string, email: string, password: string) => {
      await authStore.register(username, email, password);
      navigate('/');
    },
    [authStore, navigate]
  );

  const guestLoginAndRedirect = useCallback(
    async (username: string) => {
      await authStore.loginAsGuest(username);
      navigate('/');
    },
    [authStore, navigate]
  );

  const googleLoginAndRedirect = useCallback(
    async (credential: string) => {
      await authStore.loginWithGoogle(credential);
      navigate('/');
    },
    [authStore, navigate]
  );

  return {
    user: authStore.user,
    token: authStore.token,
    isAuthenticated: authStore.isAuthenticated,
    isLoading: authStore.isLoading,
    error: authStore.error,
    clearError: authStore.clearError,
    login: loginAndRedirect,
    register: registerAndRedirect,
    loginAsGuest: guestLoginAndRedirect,
    loginWithGoogle: googleLoginAndRedirect,
    logout,
  };
}
